export const GET_FORM_INFO = "GET_FORM_INFO";
export const CLEAR_FORM_INFO = "CLEAR_FORM_INFO";
